module.exports = __webpack_public_path__ + "img/login.60e2a3a9.svg";